import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-three',
  templateUrl: './explore-three.component.html',
  styleUrls: ['./explore-three.component.scss']
})
export class ExploreThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
